import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetLateShipments = (dateFrom: Date, dateTo: Date) => {
    const { data, isLoading } = useQuery({
        queryKey: ['late-shipments', dateFrom, dateTo],
        queryFn: async () => await apiClient.get('purchase-order/late-shipments',
            {
                params: {
                    dateFrom,
                    dateTo
                }
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
